import initialState from '../initialState.js';
import {
    GET,
    SET_PRODUCTS,
    REMOVE_PRODUCT
} from '../../actions/types/marketplace';

export default (state = initialState.marketplace, action) => {
    switch (action.type) {
        case GET: {
            return {
                ...state,
                ...action.marketplace
            };
        }

        case SET_PRODUCTS: {
            return {
                ...state,
                purchasedProducts: action.data
            };
        }

        case REMOVE_PRODUCT: {
            const availableProducts = state.availableProducts;
            delete availableProducts[action.productID];

            return {
                ...state,
                availableProducts: { ...availableProducts }
            };
        }

        default:
            return state;
    }
};